import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/GlossaryTip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/MethodologyCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/MethodologyLiveBanner.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
